import { CreateEverestTopupLinkRequest } from "@/central-atoms/everest-fleet-pwa/requests";
import {
  CreateEverestTopupLinkResponse,
  EverestTopupHistoryResponse,
  EverestTopupStatusResponse,
} from "@/central-atoms/everest-fleet-pwa/responses";
import { API_BASE_URL } from "@/constants";
import { apiClient } from "../apiClient";

/**
 * Driver top-up through Everest's Razorpay account. Only offered when `driver_details` carries
 * `topup.enabled` (the `everest_checkin_apis` rollout); the Paytm submit flow is untouched.
 */
class EverestTopupService {
  static async createTopupLink(
    reqBody: CreateEverestTopupLinkRequest
  ): Promise<CreateEverestTopupLinkResponse> {
    const response = await apiClient.post(
      `${API_BASE_URL}/driver/everest/topup/create`,
      reqBody
    );
    return response.data;
  }

  static async getTopupStatus(orderId: string): Promise<EverestTopupStatusResponse> {
    const response = await apiClient.get(`${API_BASE_URL}/driver/everest/topup/status`, {
      params: { order_id: orderId },
    });
    return response.data;
  }

  static async getTopupHistory(): Promise<EverestTopupHistoryResponse> {
    const response = await apiClient.get(`${API_BASE_URL}/driver/everest/topup/history`);
    return response.data;
  }
}

export default EverestTopupService;
